import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=547ea422&scoped=true&"
import script from "./echarts.vue?vue&type=script&lang=js&"
export * from "./echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547ea422",
  null
  
)

export default component.exports